import { ClientData } from '@interfaces';
import { createAction, props } from '@ngrx/store';

export const LoadPersonalData = createAction('[Personal Data] Load Personal Data');
export const LoadPersonalDataClientFail = createAction(
  '[Personal Data] Load Client Personal Data Fail',
);
export const LoadPersonalDataSuccess = createAction('[Personal Data] Load Personal Data Success');
export const LoadPersonalDataPayloadSuccess = createAction(
  '[Personal Data] Load Personal Data Payload Success',
  props<{ payload: ClientData }>(),
);

export const RedirectToPVR = createAction(
  '[Personal Data] Failed to retrieve prospect data, redirecting to PVR',
);
export const UpdateClientSegment = createAction(
  '[Client Flags] Update Client Segment',
  props<{ payload: string }>(),
);
export const UpdateClientFlagDigitalAdvise = createAction(
  '[Client Flags] Update Client Flag Digital Advise Segment',
  props<{ payload: boolean }>(),
);
